




































































import { Vue, Component, Mixins } from 'vue-property-decorator';

import UserChart from '@/views/statistics-analy/charts/user.vue';
import UserTotal from '@/views/statistics-analy/charts/user_total.vue';
import UserBillCount from '@/views/statistics-analy/charts/user_bill_count.vue';
import UserPlayCount from '@/views/statistics-analy/charts/user_play_count.vue';

import UserPlayerCountRank from '@/views/statistics-analy/charts/user_player_count.vue';
import UserCreditCountRank from '@/views/statistics-analy/charts/user_credit_count.vue';

import MyCommon from '@/mixins/common';
import DailyActiveUser from './charts/daily-active-user.vue';

@Component({
  components: {
    UserChart,
    UserTotal,
    UserBillCount,
    UserPlayCount,
    UserPlayerCountRank,
    UserCreditCountRank,
    DailyActiveUser,
  },
})
export default class extends Mixins(MyCommon) {
  info: any = {
    ccount1: 0,
  };

  async mounted() {
    const res = await this.$store.dispatch('users/overview', {});
    if (res && res.Data) {
      this.info = res.Data;
    }
  }
}
